import React from 'react';
import { maskCapitalizeFirstLetterOnly } from '../../../masks';

const ClientPreferencesNav = props => {
  const { subject: client, className } = props;
  const { portion_size, dietary_preference_tags, allergen_tags } = client;

  if (!portion_size && !dietary_preference_tags && !allergen_tags) return '';

  // get arrays of the strings to display
  const tags = dietary_preference_tags
    ? dietary_preference_tags.map(tag => tag.abbreviation)
    : [];
  const allergens = allergen_tags
    ? allergen_tags.map(
        allergen => `No ${maskCapitalizeFirstLetterOnly(allergen.tag)}`
      )
    : [];

  // combine to a single ordered array
  const words = [
    maskCapitalizeFirstLetterOnly(portion_size),
    ...tags,
    ...allergens
  ];

  // combine to a single string
  let string = words.join(', ').trim();
  // ellipsis if needed
  if (string.length > 20) string = `${string.slice(0, 20).trim()}...`;

  return <div className={className}>{string}</div>;
};

export default ClientPreferencesNav;



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientPreferencesNav.js